import {Controller} from 'stimulus';

export default class extends Controller {
  open(e) {
    window.location.replace(e.target.value);
  }
}

